import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CookiesContextProps {
  showCookiesContainer: boolean;
  setShowCookiesContainer: (value: boolean) => void;
}

const CookiesContext = createContext<CookiesContextProps | undefined>(undefined);

interface CookiesProviderProps {
  children: ReactNode;
}

export const CookiesProvider: React.FC<CookiesProviderProps> = ({ children }) => {
  const [showCookiesContainer, setShowCookiesContainer] = useState(false);

  return (
    <CookiesContext.Provider value={{showCookiesContainer,setShowCookiesContainer }}>
      {children}
    </CookiesContext.Provider>
  );
};

export const useCookiesContext = (): CookiesContextProps => {
  const context = useContext(CookiesContext);
  if (!context) {
    throw new Error('useCookiesContext must be used within a CookiesProvider');
  }
  return context;
};